// Environment-based API URL configuration
// Vite uses import.meta.env.MODE (development, staging, testing, production)
const getServiceApiUrl = () => {
  const env = import.meta.env.MODE || "development";

  switch (env) {
    case "production":
      return import.meta.env.VITE_API_BASE_URL_PRODUCTION;
    case "staging":
      return import.meta.env.VITE_API_BASE_URL_STAGING;
    case "testing":
      return import.meta.env.VITE_API_BASE_URL_TESTING;
    case "development":
    default:
      return import.meta.env.VITE_API_BASE_URL_LOCAL;
  }
};

const service_api = getServiceApiUrl();

// Socket API URL - typically same as service API but for WebSocket connections
const socket_api = getServiceApiUrl();

const logo_url = "https://panichef.s3.us-east-2.amazonaws.com/logo.png";

export { logo_url, service_api, socket_api };
